<div class="container-fluid animated fadeIn fast">
  <app-patient-form *ngIf="!orderPatientValid" (selectedPatient)="patientChangeEvent($event)"></app-patient-form>

  <mat-card class="mt-3" *ngIf="orderPatientValid">
    <mat-card-title>
      Paciente
    </mat-card-title>
    <mat-card-content>
      <div class="form-row" >
        <mat-form-field class="col-md-4">
            <mat-label>DNI</mat-label>
            <input matInput placeholder="" value="{{ newOrder.get('patient.fiscalCode').value }}" name="dni" [disabled] = "orderPatientValid">
          </mat-form-field>
        <mat-form-field class="col-md-4">
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="" value="{{ newOrder.get('patient.name').value}}" name="name" [disabled] = "orderPatientValid">
        </mat-form-field>
        <mat-form-field class="col-md-4">
          <mat-label>Apellido</mat-label>
          <input matInput placeholder="" value="{{ newOrder.get('patient.surname').value }}" name="surname" [disabled] = "orderPatientValid">
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <form [formGroup]="newOrder">
    <mat-card class="mt-3">
      <mat-card-title [class.text-disabled]="!orderPatientValid">
      Solicitud
      <button type="button" mat-icon-button class="add-note" [class.has-note]="newOrder.get('noteSector').value != ''" 
        (click)="addNotes($event); $event.preventDefault()" [disabled]="!orderPatientValid">
        <mat-icon>note_add</mat-icon>
      </button>
      </mat-card-title>
      <mat-card-content>
        <div class="row" >
          <mat-form-field class="col-md-4">
            <mat-label>Número de solicitud externo</mat-label>
            <input matInput type="text"
              name="orderExternalId" autofocus
              formControlName="externalOrderId">
          </mat-form-field>
          <mat-form-field class="col-md-4">
            <mat-label>Fecha de ingreso</mat-label>
            <input matInput type="text"
              formControlName="orderDate" >
          </mat-form-field>
          <mat-form-field class="col-md-4">
            <mat-label>Urgencia</mat-label>
            <mat-select  formControlName="priorityLevel">
            <mat-option *ngFor="let priorityLevel of prioritiesLevel" value="{{priorityLevel.id}}">
                {{priorityLevel.name}}
            </mat-option>
            </mat-select>
           </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field class="col-md-4">
            <mat-label>Médico solicitante</mat-label>
            <input matInput placeholder="" name="doctor"
            [ngbTypeahead]="searchDoctor" [resultFormatter]="formatMatchesDoctor"
            [inputFormatter]="formatMatchesDoctor" formControlName="doctor">
          </mat-form-field>
        <mat-form-field class="col-md-4">
            <mat-label>Servicio</mat-label>
            <mat-select  formControlName="ward" (selectionChange)="loadEntes()">
            <mat-option *ngFor="let ward of wards" value="{{ward.wardId}}" [value]="ward">
                {{ward.wardDescription}}
            </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field  class="col-md-4">
            <mat-label>Ente</mat-label>
            <mat-select formControlName="ente" >
                <mat-option *ngFor="let ente of entes" [value]="ente">{{ente.enteDescription}}
              </mat-option>
            </mat-select>

        </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="mt-3">
      <mat-card-title [class.text-disabled]="!orderInfoValid">
        Análisis
      </mat-card-title>
      <mat-card-content>

        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-6">
                <mat-form-field>
                  <input type="text" #testInput
                         placeholder="Pick one"
                         aria-label="Number"
                         matInput
                         #testInput
                         [disabled]="!orderInfoValid"
                         (keydown.enter)="searchByCode(testInput); $event.preventDefault()"
                           placeholder="Ingrese código de análisis">
                           <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="showTestsDialog(); $event.preventDefault()" [disabled]="!orderInfoValid">
                            <mat-icon>list_alt</mat-icon>
                          </button>
                  <small *ngIf="searching" class="form-text text-muted">Buscando...</small>
                  <small  *ngIf="searchFailed">
                    No existe tal test
                  </small>
                </mat-form-field>
              </div>
              <div class="col-6">

              </div>
            </div>
            <div class="row" *ngIf="searchTests">


              <div class="col-md-8">



              </div>

            </div>



            <!--mat-form-field>
              <input type="text" #testInput
                     placeholder="Pick one"
                     aria-label="Number"
                     matInput
                     [matAutocomplete]="auto"
                     [ngbTypeahead]="searchTest" formArrayName="tests"
                       [resultFormatter]="formatMatches" [inputFormatter]="formatMatches"
                       placeholder="Busqueda de analisis">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectTest($event, testInput)">
                <mat-option *ngFor="let test of tests" [value]="test">
                  {{test.id + ' - ' + test.description + ' - ' + test.specimenId}}
                </mat-option>

              </mat-autocomplete>
              <small  *ngIf="searchFailed">
                No existe tal test
              </small>
              <small *ngIf="searching" class="form-text text-muted">Buscando...</small>
            </mat-form-field-->
          </div>
          <div class="col-md-4">
            <label *ngIf="formTest.controls.length !=0"><span >Análisis seleccionados</span></label>
            <div>
              <mat-chip-list>
                <mat-chip color="primary"  *ngFor="let test of formTest.controls; let i = index"
                [matTooltip]="test.value.description" removable="true" (removed)="removeTest(i)"
                [class.profile-chip]="test.value.type =='P'">
                 {{test.value.id}}
                 <mat-icon matChipRemove >cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>

            </div>
          </div>


        </div>



      </mat-card-content>
    </mat-card>

    <div class="row mt-3">
      <div class="ml-auto mr-auto">
        <button type="button" mat-raised-button color="secondary" (click)="clearForm()" > Limpiar </button>
        <button type="button" mat-raised-button color="primary" (click)="saveOrder()" [disabled]="newOrder.invalid" > Guardar </button>
        <button type="button" mat-raised-button color="accent" (click)="sampleCalculation()" [disabled]="newOrder.invalid" *ngIf="group?.sampleGeneration"> Calcular </button>
        <button type="button" mat-raised-button color="accent" (click)="sendOrder(); $event.preventDefault()" [disabled]="newOrder.invalid" *ngIf="!group?.sampleGeneration" > Enviar </button>

      </div>
    </div>

  </form>

  <!--
  <div class="row mt-3">
    <div class="col-lg-12">-->
      <!--<app-patient-form *ngIf="!orderPatientValid" (selectedPatient)="patientChangeEvent($event)"></app-patient-form>
           <div class="card" *ngIf="orderPatientValid">
            <div class="card-header">
              Paciente Seleccionado
            </div>
            <div class="card-body">
                <div class="row">
                  <div class="col-lg-4">
                      <label>Nombre y apellido</label>
                      <label>{{ newOrder.get('patient.name').value}} {{ newOrder.get('patient.surname').value }}</label>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>DNI</label>
                      <label>{{ newOrder.get('patient.fiscalCode').value }}</label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Sexo</label>
                      <label>{{ newOrder.get('patient.sex').value }}</label>
                    </div>
                  </div>
                </div>
            </div>
          </div> -->
 <!--        <div class="card" *ngIf="orderPatientValid">
            <div class="card-header">
              Nueva orden
            </div>
            <div class="card-body">
              <form [formGroup]="newOrder" (ngSubmit)="sampleCalculation(samplesModal)">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Número de solicitud externo</label>
                      <input type="text"
                             class="form-control"
                             name="orderExternalId" autofocus
                             formControlName="externalOrderId">
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Fecha de ingreso</label> -->
<!--                      <app-calendar placeholder="dd/mm/yyyy"-->
<!--                                    [formGroup]="newOrder"-->
<!--                                    inputName="orderDate">-->
<!--                      </app-calendar>-->
 <!--                     <input type="text" class="form-control" formControlName="orderDate">
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Urgencia</label>
                      <select class="form-control"
                              formControlName="priorityLevel">
                        <option value="" [selected]="true">Seleccione Urgencia</option>
                        <option [ngValue]="priorityLevel.id" *ngFor="let priorityLevel of prioritiesLevel">{{ priorityLevel.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label for="typeahead-http-doctor">Médico solicitante:</label>
                      <input id="typeahead-http-doctor" type="text" class="form-control"
                             [class.is-invalid]="searchFailedDoctor" [ngbTypeahead]="searchDoctor" formControlName="doctor"
                             [resultFormatter]="formatMatchesDoctor" [inputFormatter]="formatMatchesDoctor" placeholder="Búsqueda de doctor" />
                      <small *ngIf="searchingDoctor" class="form-text text-muted">Buscando...</small>
                      <div class="invalid-feedback" *ngIf="searchFailedDoctor">No existe el doctor buscado</div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Servicio solicitante</label>
                      <select class="form-control"
                              name="ward"
                              formControlName="ward"
                              (change)="loadEntes()">
                        <option value="" selected="selected">Seleccionar servicio</option>
                        <option *ngFor="let ward of wards" [ngValue]="ward">{{ward.wardDescription}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Ente</label>
                      <select class="form-control"
                              formControlName="ente">
                        <option value="" [selected]="true">Seleccionar Ente</option>
                        <option *ngFor="let ente of entes" [ngValue]="ente">{{ente.enteDescription}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="typeahead-http-test">Test:</label>
                      <input id="typeahead-http-test" type="text" class="form-control" #testInput
                             [class.is-invalid]="searchFailed" [ngbTypeahead]="searchTest" formArrayName="tests"
                             [resultFormatter]="formatMatches" [inputFormatter]="formatMatches"
                             (selectItem)="selectTest($event, testInput)" placeholder="Busqueda de analisis" />
                      <small *ngIf="searching" class="form-text text-muted">Buscando...</small>
                      <div class="invalid-feedback" *ngIf="searchFailed">No existe tal test</div>
                    </div>
                  </div>
                  <div class="col-lg-9">
                    <label>Análisis seleccionados</label>
                    <div>
                      <button type="button" class="btn btn-dark" *ngFor="let test of formTest.controls; let i = index" (click)="removeTest(i)" style="margin-right: 10px;">
                        {{ test.value.testId }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4">
                    <div class="col-md-6 ml-auto mr-auto">
                      <div class="form-group">
                        <button type="button" (click)="clearForm()" class="btn btn-block  btn-primary btn-round" id="clear" style="background: #af9900 !important; border-color: #af9900!important;">
                          <span class="btn-label">
                              <i class="fas fa-eraser"></i>
                          </span>
                          <strong>LIMPIAR</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 ml-auto">
                    <div class="col-md-6 ml-auto mr-auto">
                      <div class="form-group">
                        <button type="button" class="btn btn-block btn-primary btn-round" (click)="saveOrder()" [disabled]="isValidFormForSave()">
                          <span class="btn-label">
                              <i class="fa fa-search"></i>
                          </span>
                          <strong>GUARDAR</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 ml-auto">
                    <div class="col-md-6 ml-auto mr-auto">
                      <div class="form-group">
                        <button type="submit"class="btn btn-block btn-success btn-round" [disabled]="newOrder.invalid">
                          <span class="btn-label">
                              <i class="fa fa-search"></i>
                          </span>
                          <strong>CALCULAR</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
      </div>
    </div>
  </div> -->
  <!--hr>
    <pre>
    {{ group | json}}
  </pre>
  <pre>
    {{ newOrder.value | json}}
  </pre>
  <pre>
    new order: {{ newOrder.status | json}}
  </pre>
  <pre>
    {{ samplesForm.value | json}}
  </pre>
  <pre>
    Samples: {{ samplesForm.status | json}}
  </pre-->
</div>
<ng-template #samplesModal let-c="close" let-d="dismiss" class="animated fadeIn fast">
  <div class="modal-header">
     <h4 class="modal-title" id="modal-basic-title">INGRESAR NÚMEROS DE ETIQUETAS</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="samplesForm" (ngSubmit)="verifyAndSendOrder()">
      <div formArrayName="samples">
        <div class="row" *ngFor="let sample of samplesForm.get('samples').value; let i = index; trackBy: trackByFn">
          <div [formGroupName]="i" class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ sample.containerId }}</span>
            </div>
            <input type="text" class="form-control" formControlName="labelId">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" placement="top" [ngbTooltip]="testFromSamples(sample.tests)" [openDelay]="300" [closeDelay]="500">Analisis</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <button class="btn btn-block btn-outline-success" [disabled]="newOrder.invalid && samplesForm.invalid" type="submit">Enviar Solicitud</button>
      </div>
    </form>
  </div>
</ng-template>
